import { render, staticRenderFns } from "./Portrait.vue?vue&type=template&id=8ca0d00e"
import script from "./Portrait.vue?vue&type=script&lang=js"
export * from "./Portrait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports